import React from 'react'
import { Segment, Table } from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'
import {connect} from 'react-redux'
import {getTemplatesAction} from '../../../../../actions/template.action'
import {describeRecurrence, legacyDescribeRecurrence} from '../../../../../utils/recurrence'
import EditRepeatRuleModal from './EditRepeatRuleModal'
import EditRepeatRuleIssueModal from './EditRepeatRuleIssueModal'

function getRuleSchedule (rule) {
  if (rule.recurrence && rule.recurrence.frequency) {
    return describeRecurrence(rule.recurrence, rule.recurrence.anchor || rule.next_run)
  }
  return legacyDescribeRecurrence(rule.repeat_period)
}

class RepeatRulePanel extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      repeatRules: [],
      editingRule: null,
      editingIssueRule: null
    }
  }
  loadRepeatRules () {
    const api = createAPIClient()
    api.get(`/api/repeatrule?template=${this.props.templateId}`)
      .then(result => {
        this.setState({repeatRules: result.data})
      })
      .catch(error => {
        console.log(error)
      })
  }
  deleteRepeatRule (e, id) {
    e.preventDefault()
    const api = createAPIClient()
    api.delete(`/api/repeatrule/${id}`)
      .then(result => {
        this.loadRepeatRules()
      })
  }
  openEdit (e, rule) {
    e.preventDefault()
    this.setState({editingRule: rule})
  }
  openEditIssue (e, rule) {
    e.preventDefault()
    this.setState({editingIssueRule: rule})
  }
  closeEdit () {
    this.setState({editingRule: null})
  }
  closeEditIssue () {
    this.setState({editingIssueRule: null})
  }
  onEditSaved () {
    this.setState({editingRule: null})
    this.loadRepeatRules()
  }
  onEditIssueSaved () {
    this.setState({editingIssueRule: null})
    this.loadRepeatRules()
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.templateId !== this.props.templateId) {
      this.loadRepeatRules()
    }
  }
  componentDidMount () {
    this.loadRepeatRules()
  }

  render () {
    const tableRows = (
      <Table.Body>
        {this.state.repeatRules.map(rule => {
          return (
            <Table.Row key={rule._id}>
              <Table.Cell>
                <a href='#' onClick={(e) => this.openEdit(e, rule)}>Edit</a>
                {' | '}
                <a href='#' onClick={(e) => this.openEditIssue(e, rule)}>Template</a>
                {' | '}
                <a href='#' onClick={(e) => this.deleteRepeatRule(e, rule._id)}>Delete</a>
              </Table.Cell>
              <Table.Cell>{rule.name}</Table.Cell>
              <Table.Cell>{getRuleSchedule(rule)}</Table.Cell>
              <Table.Cell> {rule.last_run ? new Date(rule.last_run).toLocaleString() : ""} </Table.Cell>
              <Table.Cell>{new Date(rule.next_run).toLocaleString()}</Table.Cell>
              <Table.Cell>{rule.status}</Table.Cell>
            </Table.Row>
          )
        })}
      </Table.Body>
    )
    const table = (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{width: '150px'}} />
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Schedule</Table.HeaderCell>
            <Table.HeaderCell>Last run</Table.HeaderCell>
            <Table.HeaderCell>Next run</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {tableRows}
      </Table>
    )
    const content = this.state.repeatRules.length > 0
      ? table
      : 'There are no repeat rules'

    return (
      <Segment>
        {content}
        <EditRepeatRuleModal
          open={!!this.state.editingRule}
          rule={this.state.editingRule}
          onClose={this.closeEdit.bind(this)}
          onSaved={this.onEditSaved.bind(this)}
        />
        <EditRepeatRuleIssueModal
          key={this.state.editingIssueRule && this.state.editingIssueRule._id}
          open={!!this.state.editingIssueRule}
          rule={this.state.editingIssueRule}
          templateId={this.props.templateId}
          customFields={this.props.customFields}
          labels={this.props.labels}
          onClose={this.closeEditIssue.bind(this)}
          onSaved={this.onEditIssueSaved.bind(this)}
        />
      </Segment>
    )
  }
}
function mapStateToProps (state) {
  return {locations: state.account.user.locations, templates: state.templates.templates}
}

export default connect(mapStateToProps, {getTemplatesAction})(RepeatRulePanel)



// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/repeatrulepanel/index.js